/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CloneEnvironmentRequestBody = {
  /**
   * If true, copy the encrypted secret values from the source. If false (default), copy only variable names with empty placeholder values.
   */
  copyValues?: boolean | undefined;
  /**
   * The name for the new cloned environment
   */
  newName: string;
};

/** @internal */
export type CloneEnvironmentRequestBody$Outbound = {
  copy_values?: boolean | undefined;
  new_name: string;
};

/** @internal */
export const CloneEnvironmentRequestBody$outboundSchema: z.ZodMiniType<
  CloneEnvironmentRequestBody$Outbound,
  CloneEnvironmentRequestBody
> = z.pipe(
  z.object({
    copyValues: z.optional(z.boolean()),
    newName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      copyValues: "copy_values",
      newName: "new_name",
    });
  }),
);

export function cloneEnvironmentRequestBodyToJSON(
  cloneEnvironmentRequestBody: CloneEnvironmentRequestBody,
): string {
  return JSON.stringify(
    CloneEnvironmentRequestBody$outboundSchema.parse(
      cloneEnvironmentRequestBody,
    ),
  );
}
